import { LexicalEditor } from 'lexical';

const pageDesignerPath = '/page-designer';

export const deleteAction = (editor: LexicalEditor, remove: () => void) => {
  editor.update(() => {
    remove();
  });
};

export const createActionButton = (
  executor: () => void,
  className?: string,
) => {
  const currentPath = window.location.pathname;

  if (!currentPath.includes(pageDesignerPath)) {
    return '';
  }

  const actionButton: HTMLElement = document.createElement('div');
  actionButton.addEventListener('click', executor);

  if (className) {
    actionButton.classList.add(className);
  }

  return actionButton;
};
